import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import '../../scss/style/confirmsignup.scss'
import happyFace from '../../assets/images/happyface.png'

export default function ConfirmSignUp() {
    const navigate = useNavigate();
    const { isAuthenticated, login, profile, confirmSignUp } = useAuth();

    const getTokenFromURL = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('token_hash');
    };


    const confirmSignUpAsync = async () => {
        const tokenHash = getTokenFromURL();

        if (tokenHash) {
            await confirmSignUp(tokenHash);
            console.log('authstate', await isAuthenticated);
        }
    };
    confirmSignUpAsync();

    const navigateToHome = async () => {
        const accessToken = localStorage.getItem('accessToken');
        const email = localStorage.getItem('email');
        const password = localStorage.getItem('password');
        if (accessToken) {
            const result = await login({ email, password });
            await profile();
            if (result) {
                navigate('/');
            }

        } else {
            console.error('Access token not found in local storage');
        }
    };

    return (
        <div className='confirm-container'>
            <img src={happyFace} alt='happy face' className='happy-photo' />
            <p className='confirmation-text'>Confirmation Succeeded</p>
            <button className='go-button' onClick={navigateToHome}>Go to Home Page</button>
        </div>
    );
}
